import { DataSyncSourceProductStore } from './DataSyncSourceProductStore';
import { DataSyncDestinationProductStore } from './DataSyncDestinationProductStore';
import { ProductInstancesStore } from './ProductInstancesStore';

/**
 * Factory class for managing singleton instances of product stores.
 * Implements lazy initialization - stores are only created when first accessed.
 */
class ProductStoreFactory {
  /**
   * Get the singleton instance of ProductInstancesStore.
   * Creates the instance on first call (lazy initialization).
   */
  public static getProductInstancesStore(): ProductInstancesStore {
    if (!this.productInstancesStoreInstance) {
      this.productInstancesStoreInstance = new ProductInstancesStore();
    }
    return this.productInstancesStoreInstance;
  }

  /**
   * Get the singleton instance of DataSyncSourceProductStore.
   * Creates the instance on first call (lazy initialization).
   */
  public static getSourceProductStore(): DataSyncSourceProductStore {
    if (!this.sourceProductStoreInstance) {
      this.sourceProductStoreInstance = new DataSyncSourceProductStore();
    }
    return this.sourceProductStoreInstance;
  }

  /**
   * Get the singleton instance of DataSyncDestinationProductStore.
   * Creates the instance on first call (lazy initialization).
   */
  public static getDestinationProductStore(): DataSyncDestinationProductStore {
    if (!this.destinationProductStoreInstance) {
      this.destinationProductStoreInstance = new DataSyncDestinationProductStore();
    }
    return this.destinationProductStoreInstance;
  }

  /**
   * Reset all store instances. Useful for testing.
   */
  public static reset(): void {
    this.productInstancesStoreInstance = null;
    this.sourceProductStoreInstance = null;
    this.destinationProductStoreInstance = null;
  }

  private static productInstancesStoreInstance: ProductInstancesStore | null = null;
  private static sourceProductStoreInstance: DataSyncSourceProductStore | null = null;
  private static destinationProductStoreInstance: DataSyncDestinationProductStore | null = null;
}

export default ProductStoreFactory;
